import { Modal } from 'antd'
import deleteTimesheet from '../Services/delete'

export default () => (dispatch) => {

  Modal.confirm({
    title: `Are you sure to delete this Posting?`,
    content: 'Note: This action cannot be undone',
    okText: 'Yes',
    width: 400,
    onOk: () => dispatch(deleteTimesheet()),
  })

}
